class CoreHeaderNavController {
    constructor(shopperService, analyticsService, settingsService, $rootScope, $location, breakpointsService) {
        this.shopperService = shopperService;
        this.analyticsService = analyticsService;
        this.settings = settingsService.settings;
        this.isReorder = false;
        this.isMyList = false;
        this.breakpointsService = breakpointsService;

        //  As part of quick reorder experiment
        $rootScope.$on('$locationChangeStart', (event, next) => {
            this.updateReorderStatus(next);
        });

        this.updateReorderStatus($location.path());
        //  As part of quick reorder experiment end
        this.listMenuText = 'Lists';
        this.quickReorderMenuText = 'Quick Reorder';

        if (this.settings.quickReorder.quickReorderPageName) {
            this.quickReorderMenuText = this.settings.quickReorder.quickReorderPageName;
        }

        if (this.settings.lists.enableListHome === true) {
            this.listMenuText = 'Lists';
        }

        this.listMenuLink = 'shop.list.home';

        if (this.shopperService.IsGuest && this.settings.lists.enableListHome === false) {
            this.listMenuLink = 'shop.guestList';
        }
    }

    showCoachMarkForList() {
        return this.settings.lists.enableListHome && this.settings.lists.showCoachmarkOnTopNav;
    }

    showCoachMarkForQuickReorder() {
        return this.settings.content.enableQuickReorder && this.settings.quickReorder.showCoachmarkOnTopNav;
    }

    coachMarkForListPosition() {
        if (this.breakpointsService.isSmallFormat()) {
            return 'right';
        }

        return 'top right';
    }

    coachMarkForQuickReorderPosition() {
        if (this.breakpointsService.isSmallFormat()) {
            return 'right';
        }

        return 'top right';
    }

    //  As part of quick reorder experiment
    updateReorderStatus(currentUrl) {
        this.isReorder = currentUrl.indexOf('/mylists/reorder') >= 0;
        this.isMyList = currentUrl.indexOf('/mylists') >= 0 && !this.isReorder;
    }


    pushDataToAnalyticsService() {
        this.analyticsService.push({
            data: {
                trackingType: 'link',
            },
            type: this.analyticsService.mapperTypes.customEvent.menuClick,
        });
    }
}

const coreHeaderNavComponentDefinition = {
    bindings: {
        classModifier: '@?',
        onInspirationSelected: '&?',
        onRecipesSelected: '&?',
    },
    controller: ['ShopperService', 'AnalyticsService', 'SettingsService', '$rootScope', '$location', 'BreakpointsService', CoreHeaderNavController],
    template: require('./core-header-nav.component.html').trim(),
};

module.exports = {
    CoreHeaderNavController,
    coreHeaderNavComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/header/core-header-nav.component.js